import Cookies from "js-cookie"
import {useEffect, useRef, useState} from "react"
import {v4 as uuidv4} from "uuid"

import Page from "@/components/Page"
import PageContent from "@/components/PageContent"
import ChatPanel from "@/components/ui/ChatPanel"
import StartAgain from "@/components/ui/StartAgain"
import UserInput from "@/components/ui/UserInput"
import {useTheme} from "@/hooks/useTheme"
import {useWebsocket} from "@/hooks/useWebsocket"
import {cn} from "@/lib/utils"

const BOT_CLIENT_ID_COOKIE_KEY = "BotClientId"

const ChatPage: React.FC = () => {
    const {theme} = useTheme()
    const [userInputEnabled, setUserInputEnabled] = useState<boolean>(true)
    const {connect, closeWebsocket, messages} = useWebsocket()

    const scrollRef = useRef<HTMLDivElement>(null)

    // useEffect(() => {
    //     if (scrollRef.current) {
    //         scrollRef.current.scrollIntoView({
    //             behavior: "smooth",
    //             inline: "center",
    //         })
    //     }
    // }, [scrollRef, messages, userInputEnabled])

    useEffect(() => {
        let clientId = Cookies.get(BOT_CLIENT_ID_COOKIE_KEY)
        if (clientId === undefined) {
            Cookies.set(BOT_CLIENT_ID_COOKIE_KEY, uuidv4(), {expires: 7, secure: true, sameSite: "none"})
        }

        const ws = connect()
        return () => {
            closeWebsocket(ws)
        }
    }, [])

    return (
        <Page
            className={cn(
                theme,
                "no-scrollbar overflow-hidden rounded-frame border border-frame bg-background font-display text-[16px] font-normal leading-[133%] text-foreground sm:text-[18px]",
            )}
        >
            <PageContent>
                <div className="no-scrollbar flex h-screen flex-col justify-between gap-4 overflow-hidden">
                    <div className="no-scrollbar fixed left-0 top-0 flex-grow overflow-hidden p-3">{/* <ChatHeader /> */}</div>
                    <div className="fixed bottom-[140px] left-0 right-0 top-[1px]  flex-grow place-content-start overflow-auto p-[20px] sm:p-[30px]">
                        <ChatPanel setUserInputEnabled={setUserInputEnabled} />
                        <div className="mt-2" ref={scrollRef}></div>
                    </div>
                    <div className="no-scrollbar fixed bottom-[0px] left-0 h-[140px] w-full overflow-hidden pt-[20px]">
                        <UserInput enabled={userInputEnabled} />
                        <div className="flex w-full place-content-center p-[20px]">
                            <StartAgain />
                        </div>
                    </div>
                </div>
            </PageContent>
        </Page>
    )
}

export default ChatPage
